export default __webpack_public_path__ + "static/media/application-screenshots-01.8f8bd834.jpg";